<template>
  <div>
    <admin-filter
      ref="adminFilter"
      :items="filterData"
      :itemFiltered.sync="filtered"
      @getData="getDataFromServer"
      title="수동 설치 기능 신청 목록"
    ></admin-filter>

    <admin-table :field_list="tableData"
                 :items="tableItems"
                 :filtered="filtered"
                 :allCount="allCount"
                 :filteredCount="filteredCount"
                 :table_width="1800"
                 @getData="getDataFromServer"
                 @ordering="ordering"
                 @selPageLength="selPageLength">
      <div slot="is_subscription" slot-scope="props">
        <div v-if="props.item.app_type==='service'">-</div>
        <div v-else>{{ props.item.is_subscription?'월 결제': '건 결제' }}</div>
      </div>

      <div slot="status" slot-scope="props">
        <!-- 상태 드롭다운 -->
        <span class="select">
        <select v-model="props.item.status" @change="e=>clickStatus(props.item, e.target.value)">
          <option v-for="item in statusOptions" :key="item.id"
                  :value="item.value">{{ item.label }}</option>
        </select>
      </span>
      </div>

      <div slot="service_user" slot-scope="props">
        <div>{{ props.item.service_user.name }}</div>
        <div>{{ props.item.service_user.email }}</div>
        <div>{{ props.item.service_user.phone }}</div>
      </div>
    </admin-table>
  </div>
</template>
<script>
  import ListMixin from "../../../../mixins/ListMixin";

  export default {
    name: "ServiceAppOrderRequestList",
    mixins: [
      ListMixin
    ],
    created() {
      this.init();
    },
    data() {
      return {
        statusOptions: [
          {value: 1, label: '신청'},
          {value: 4, label: '안내완료'},
          {value: 5, label: '결제완료'},
          {value: 6, label: '작업중'},
          {value: 2, label: '이용중'}
        ],
      }
    },
    methods: {
      init() {
        this.initializing('launchpack_service_app_order_request',
          "launchpack/service/app_order/passive");
      },
      getDataFromServer() {
        this.getData();
      },
      clickStatus(item, value) {
        let url = `admin/launchpack/service/${item.service}/app_order/${item.id}`
        this.$axios.patch(url, {
          status: parseInt(value)
        }).then(res=> {
          this.toast('이용상태가 변경되었습니다.')
        }).catch(error=>{
          this.toast('서버에 오류가 발생했습니다. 관리자에게 문의주세요.')
        })
      }
    }
  }
</script>
<style lang="stylus" scoped>
</style>
